import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatToolbarModule } from '@angular/material/toolbar';
import { NSErrorModule } from '@norfolk-southern/accessns-components';

import { PreviousRequestsForm } from '@ruby/modules/diversions/forms/previous-requests/components/previous-requests.form';
import { PreviousRequestsFormContainer } from '@ruby/modules/diversions/forms/previous-requests/containers/previous-requests.container';
import { DirectivesModule } from '@ruby/shared/directives/directives.module';

@NgModule({
  declarations: [
    PreviousRequestsFormContainer,
    PreviousRequestsForm
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatButtonModule,
    MatDatepickerModule,
    MatFormFieldModule,
    NSErrorModule,
    MatInputModule,
    MatSelectModule,
    MatToolbarModule,
    ReactiveFormsModule,
    DirectivesModule
  ],
  exports: [
    PreviousRequestsFormContainer
  ]
})
export class PreviousRequestsFormModule {}
